import { render, staticRenderFns } from "./SingleButton.vue?vue&type=template&id=0fc55aa4&scoped=true"
import script from "./SingleButton.vue?vue&type=script&lang=ts"
export * from "./SingleButton.vue?vue&type=script&lang=ts"
import style0 from "./SingleButton.vue?vue&type=style&index=0&id=0fc55aa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc55aa4",
  null
  
)

export default component.exports